export default "__VITE_ASSET__p4tfcOEu__"